import React from 'react';
import { ArrowDownNarrowWide, ArrowUpNarrowWide } from 'lucide-react';
import Pagination from '../../../components/ui/pagination/Pagination';
import EditAssetModal from '../../../components/modals/assets/EditAssetModal';
import ManageBasesModal from '../../../components/modals/assets/ManageBasesModal';
import AddAssetModal from '../../../components/modals/assets/AddAssetModal';
import SortableHeader from '../../../components/ui/table/SortableHeader';

const OffshoreSymbolsContent = ({
  tab = 'offshore_symbols',

  pageAssets = [],

  sortBy,
  sortOrder,
  sortByOptions = [],
  handleSort,

  pagination,
  handlePageChange,

  editAssetId,
  showEditAssetModal,
  setShowEditAssetModal,
  handleEditAsset,
  handleEditModalSuccess,

  showManageBasesModal,
  handleManageBasesClose,
  handleManageBasesSuccess,

  showAddAssetModal,
  handleAddAssetClose,
  handleAddAssetSuccess,
}) => {
  return (
    <div className="min-w-0 self-start">
      <div className="px-2">
        <div
          className="grid items-center gap-4 text-blueDarker text-base font-semibold px-1 py-2"
          style={{
            gridTemplateColumns: '2.7fr 110px 90px 140px 100px 140px 70px',
          }}
        >
          <SortableHeader field="name" label="Nome" sortBy={sortBy} sortOrder={sortOrder} onSort={handleSort} />

          <SortableHeader field="ticker" label="Ticker" sortBy={sortBy} sortOrder={sortOrder} onSort={handleSort} />

          <SortableHeader field="currency" label="Moeda" sortBy={sortBy} sortOrder={sortOrder} onSort={handleSort} />

          <SortableHeader field="exchange" label="Exchange" sortBy={sortBy} sortOrder={sortOrder} onSort={handleSort} />

          <SortableHeader field="country" label="País" sortBy={sortBy} sortOrder={sortOrder} onSort={handleSort} />

          <SortableHeader
            field="strategy"
            label="Estratégia"
            sortBy={sortBy}
            sortOrder={sortOrder}
            onSort={handleSort}
          />

          <div className="truncate text-right">&nbsp;</div>
        </div>
      </div>

      <div className="space-y-0 mt-1">
        {pageAssets.map((asset, idx) => {
          const isWhiteRow = idx % 2 !== 1;

          return (
            <div key={asset.id} className={`${isWhiteRow ? 'bg-white' : 'bg-transparent'} rounded-xl`}>
              <div
                className="grid items-center gap-4 px-3 py-3"
                style={{
                  gridTemplateColumns: '2.7fr 110px 90px 140px 100px 140px 70px',
                }}
              >
                <div
                  className="min-w-0 flex items-center gap-2 font-semibold text-blueDarker"
                  title={asset.displayName}
                >
                  <span
                    className="flex-none block rounded"
                    style={{
                      backgroundColor: asset.colorHex,
                      width: '12px',
                      height: '12px',
                    }}
                  />
                  <span className="min-w-0 truncate">{asset.displayName}</span>
                </div>

                <div className="truncate" title={asset.ticker}>
                  {asset.ticker}
                </div>

                <div className="truncate" title={asset.currency}>
                  {asset.currency}
                </div>

                <div className="truncate" title={asset.exchange}>
                  {asset.exchange}
                </div>

                <div className="truncate" title={asset.country}>
                  {asset.country}
                </div>

                <div className="truncate text-blueDarker" title={asset.strategy}>
                  {asset.strategy}
                </div>

                <div className="flex justify-end">
                  <button
                    className="bg-tealMedium hover:opacity-90 transition-opacity text-white font-semibold rounded-full px-5 pt-3 pb-2 text-xs border-r-2 border-b-2 border-tealBase"
                    onClick={() => handleEditAsset(asset.id)}
                  >
                    EDITAR
                  </button>
                </div>
              </div>
            </div>
          );
        })}

        {pageAssets.length === 0 ? (
          <div className="bg-white rounded-custom20 p-6 text-center text-blueDarker/70">
            Nenhum ativo internacional encontrado.
          </div>
        ) : null}
      </div>

      <div className="flex items-center justify-between mt-3">
        <div className="hidden md:flex items-center gap-2 text-blueDarker text-base">
          {sortOrder === 'asc' ? (
            <ArrowUpNarrowWide size={20} strokeWidth={1.5} className="text-tealMedium" />
          ) : (
            <ArrowDownNarrowWide size={20} strokeWidth={1.5} className="text-tealMedium" />
          )}

          <span className="font-semibold text-blueDarker">Ordenado por:</span>

          <span className="text-blueDarker">{sortByOptions.find((option) => option.value === sortBy)?.label}</span>
        </div>

        <Pagination
          currentPage={pagination.currentPage}
          totalPages={pagination.totalPages}
          onPageChange={handlePageChange}
        />

        <div className="text-blueDarker text-base">
          {pagination.totalCount > 0 ? (
            <>
              <span>Mostrando </span>
              <span className="font-semibold">
                {(pagination.currentPage - 1) * pagination.perPage + 1}-
                {Math.min(pagination.currentPage * pagination.perPage, pagination.totalCount)}
              </span>
              <span> de </span>
              <span className="font-semibold">{pagination.totalCount} resultados</span>
            </>
          ) : (
            <>
              <span>Mostrando </span>
              <span className="font-semibold">0</span>
              <span> resultados</span>
            </>
          )}
        </div>
      </div>

      {showEditAssetModal && (
        <EditAssetModal
          assetId={editAssetId}
          onClose={() => setShowEditAssetModal(false)}
          onSuccess={handleEditModalSuccess}
          assetType={tab}
        />
      )}

      {showManageBasesModal && (
        <ManageBasesModal onClose={handleManageBasesClose} onSuccess={handleManageBasesSuccess} />
      )}

      {showAddAssetModal && <AddAssetModal onClose={handleAddAssetClose} onSuccess={handleAddAssetSuccess} />}
    </div>
  );
};

export default OffshoreSymbolsContent;
